"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.router = exports.handlerOther = exports.handlerOption = exports.handlerText = exports.initExecutorFromLS = exports.initExecutorFromState = exports.prepareStateFromLS = void 0;
const pythia_logic_executor_1 = __importDefault(require("@yandex-int/pythia-logic-executor"));
const effects_1 = require("redux-saga/effects");
const pythia_libs_1 = require("@yandex-int/pythia-libs");
const errors_1 = require("src/utils/errors");
const location_1 = require("src/utils/location");
const consts_1 = require("./consts");
const selectors_1 = require("./selectors");
let logicExecutor;
function initLogic({ state, search, dispatch }) {
    logicExecutor = new pythia_logic_executor_1.default({
        state: Object.assign(Object.assign({}, state), { query: (0, location_1.getQueryParams)(search) }),
        onChange: ({ status, nodes }) => {
            if (status === 'start') {
                dispatch({ type: 'LOGIC_PROCESS_START' });
            }
            else if (status === 'changed') {
                dispatch({ type: 'NODE_VISIBILITY_CHANGED', nodes });
            }
            else if (status === 'end') {
                dispatch({ type: 'LOGIC_PROCESS_END' });
            }
        },
        onError: errors_1.sendError
    });
}
function prepareStateFromLS(state) {
    state.groups = state.pages.list.reduce((obj, page) => {
        const { id } = page;
        obj[id] = Object.assign(Object.assign({}, page), { type: 'group' });
        return obj;
    }, {});
    return state;
}
exports.prepareStateFromLS = prepareStateFromLS;
function* initExecutorFromState(dispatch, action) {
    const { search } = yield (0, effects_1.select)(selectors_1.getLocation);
    initLogic({ state: action.data, search, dispatch });
}
exports.initExecutorFromState = initExecutorFromState;
function* initExecutorFromLS(dispatch) {
    const { search } = yield (0, effects_1.select)(selectors_1.getLocation);
    const state = prepareStateFromLS(yield (0, effects_1.select)(selectors_1.getState));
    initLogic({ state, search, dispatch });
}
exports.initExecutorFromLS = initExecutorFromLS;
function* handlerText({ questionIndex }) {
    const { value } = yield (0, effects_1.select)(selectors_1.getQuestion, questionIndex);
    logicExecutor.setAnswer(questionIndex, value);
}
exports.handlerText = handlerText;
function* handlerOption({ questionIndex }) {
    const question = yield (0, effects_1.select)(selectors_1.getQuestion, questionIndex);
    const answer = (0, pythia_libs_1.Question)(question).getValue();
    logicExecutor.setAnswer(questionIndex, answer);
}
exports.handlerOption = handlerOption;
function* handlerOther({ questionIndex }) {
    const question = yield (0, effects_1.select)(selectors_1.getQuestion, questionIndex);
    if (question.otherAnswerWithText) {
        logicExecutor.setOtherAnswerWithText(questionIndex, question.otherAnswerWithText.value);
    }
}
exports.handlerOther = handlerOther;
function* router({ dispatch }) {
    yield (0, effects_1.takeEvery)('SURVEY_SET_INITED', initExecutorFromState, dispatch);
    yield (0, effects_1.takeEvery)('SURVEY_RESTORED_FROM_PRELOADED_STATE', initExecutorFromLS, dispatch);
    yield (0, effects_1.takeEvery)('SURVEY_LOADED_FROM_CONFIG', initExecutorFromLS, dispatch);
    // @ts-expect-error TS(2769): No overload matches this call.
    yield (0, effects_1.takeEvery)('QUESTION_CHANGE_TEXT', handlerText);
    // @ts-expect-error TS(2769): No overload matches this call.
    yield (0, effects_1.takeEvery)('QUESTION_CHANGE_OTHER_WITH_TEXT', handlerOther);
    // @ts-expect-error TS(2769): No overload matches this call.
    yield (0, effects_1.takeEvery)(consts_1.QUESTION_ANSWER_ACTIONS, handlerOption);
}
exports.router = router;
